import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';
import { IFieldProps } from './IFieldProps';

export const RatePerMonth: React.FC<IFieldProps> = ({ baseName, readOnly }) => (
  <NumberField
    name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.RatePerMonth}`}
    label={'Rate Per Month'}
    placeholder={'0.00'}
    mode={'currency'}
    data-test-id={'fee-detail-rate-per-month'}
    readOnly={readOnly}
  />
);
